
import { ProfessionData } from '../types/professionTypes';

export const restaurateur: ProfessionData = {
  title: "Restaurateur",
  slug: "restaurateur",
  description: "Solutions de valorisation des déchets de restauration",
  icon: "ChefHat",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Biodéchets",
      description: "Restes alimentaires et déchets de préparation soumis à tri obligatoire.",
      solutions: ["Collecte spécifique", "Méthanisation"],
      environmentalBenefit: "Production biogaz et réduction émissions"
    },
    {
      type: "Huiles alimentaires usagées",
      description: "Huiles de friture nécessitant une collecte conforme à la réglementation.",
      solutions: ["Contenants normalisés", "Traçabilité complète"],
      environmentalBenefit: "Conversion en biocarburant"
    },
    {
      type: "Emballages et consommables",
      description: "Cartons, plastiques, bocaux et consommables divers.",
      solutions: ["Audit et optimisation du tri", "Collecte multi-flux"],
      environmentalBenefit: "Économie circulaire des emballages"
    },
    {
      type: "Verre",
      description: "Bouteilles et contenants en verre représentant un volume important.",
      solutions: ["Contenants spécifiques", "Collecte silencieuse"],
      environmentalBenefit: "Recyclage infini du verre"
    }
  ],
  relatedProfessions: ["traiteur", "boulanger", "hotelier"]
};
